import React, { useState } from 'react';
import CompanyDefinitionForm from './forms/CompanyDefinitionForm';
import { companyDefinitionDummyData, companyDefinitionDummyDataSets } from '../data/CompanyDefinitionDummyData';
import { Box, Button, Typography, Paper, Stack } from '@mui/material';

const TestCompanyDefinition = () => {
  const [selectedDataSet, setSelectedDataSet] = useState(0);
  const [showForm, setShowForm] = useState(false);

  const handleDataSetSelect = (index) => {
    setSelectedDataSet(index);
    setShowForm(true);
  };

  const handleBack = () => {
    setShowForm(false);
  };

  if (showForm) {
    return (
      <Box>
        <Box sx={{ p: 2, backgroundColor: '#f5f5f5', borderBottom: '1px solid #ddd' }}>
          <Button onClick={handleBack} variant="outlined" sx={{ mb: 2 }}>
            ← Back to Data Sets
          </Button>
          <Typography variant="h6">
            Testing with: {companyDefinitionDummyDataSets[selectedDataSet].name}
          </Typography>
        </Box>
        <CompanyDefinitionForm 
          fetch_id={9999} // New company creation
          initialData={companyDefinitionDummyDataSets[selectedDataSet]}
        />
      </Box>
    );
  }

  return (
    <Box sx={{ p: 3 }}>
      <Typography variant="h4" sx={{ mb: 3, textAlign: 'center' }}>
        Company Definition Form - Dummy Data Sets
      </Typography>
      
      <Typography variant="body1" sx={{ mb: 3, textAlign: 'center', color: 'text.secondary' }}>
        Select a dummy data set to test the Company Definition form
      </Typography>

      <Stack spacing={2}>
        {companyDefinitionDummyDataSets.map((dataSet, index) => (
          <Paper 
            key={index} 
            sx={{ p: 2, cursor: 'pointer', '&:hover': { backgroundColor: '#f5f5f5' } }}
            onClick={() => handleDataSetSelect(index)}
          >
            <Typography variant="h6" sx={{ mb: 1 }}>
              {dataSet.name}
            </Typography>
            <Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>
              {dataSet.address1}, {dataSet.city}, {dataSet.state} - {dataSet.pinCode}
            </Typography>
            <Typography variant="body2" color="text.secondary">
              Payroll Manager: {dataSet.payrollManager} | Email: {dataSet.email}
            </Typography>
          </Paper>
        ))}
      </Stack>

      <Box sx={{ mt: 4, p: 2, backgroundColor: '#e3f2fd', borderRadius: 1 }}>
        <Typography variant="h6" sx={{ mb: 2 }}>
          Quick Test Data
        </Typography>
        <Button 
          variant="contained" 
          onClick={() => handleDataSetSelect(0)}
          sx={{ mr: 2 }}
        >
          Use TechCorp Data
        </Button>
        <Button 
          variant="outlined" 
          onClick={() => setShowForm(true)}
        >
          Start with Empty Form
        </Button>
      </Box>
    </Box>
  );
};

export default TestCompanyDefinition;
